
export default {
  name: "header-navbar",
  props: ['isMob'],
  data() {
    return {
      openMenu: false,
      headerOptions:{
        menuList: [
          { item: "our missions", srcLink: "/our-missions/" },
          { item: "sample reports", srcLink: "/example/" },
          {
            item: "PRODUCTS & SERVICES",
            srcLink: "/products-services/"
          },
          { item: "Testimonials", srcLink: "/testimonials/" },
          { item: "About", srcLink: "/about-us/" },
          { item: "Contact", srcLink: "/contact/" },
        ],
        logoSrc:
          "/",
        btnSrc:"#find-partner",
        btnTitle:"free scan",
      },
    };
  },

  mounted() {
    
  },
  methods: {
    handleClick() {
      this.$store.commit('setFocus'); // Вызов Vuex commit

      // Реализация скроллинга
      this.scrollToElement('#find-partner');
    },
    scrollToElement(selector) {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }


};
